// Timezone-safe formatter for date-only values coming from the Black 1/1
// tracker (first_surfaced_at). The backend stores either:
//   • a plain calendar date       – "2026-05-17"
//   • an ISO datetime at UTC 00:00 – "2026-06-03T00:00:00+00:00"
// In both cases the value represents a specific calendar day. Feeding
// them into `new Date(…).toLocaleDateString()` runs a UTC→local
// conversion that silently rolls back to the previous day in western
// timezones (e.g. 2026-06-03 → 6/2/2026 in America/*).
//
// This helper extracts the intended (year, month, day) directly from
// the string and formats those components, so the displayed calendar
// day is identical regardless of the viewer's timezone.

/**
 * @param {string|null|undefined} value  A date-only or ISO datetime string.
 * @param {Object} [options]             `Intl.DateTimeFormat` options.
 * @returns {string} A localized calendar-day string, or "" for missing input.
 */
export function formatCalendarDay(value, options) {
  if (!value || typeof value !== "string") return "";
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return "";
  const [, y, m, d] = match;
  // Construct with local components — no timezone shift.
  const local = new Date(Number(y), Number(m) - 1, Number(d));
  return local.toLocaleDateString(undefined, options);
}
